import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getSentryUtil } from '../../../../main/utils/monitoring/sentry.util.ts';
import { getTrackerUtil } from '../../../../main/utils/trackers/tracker.util.ts';

import { AUTH_SLICE_NAME } from '../auth.slice.types.ts';

export const resetUserTrackersThunk = createAsyncThunk<void, undefined, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/resetUserTrackers`,
  () => {
    getTrackerUtil().reset();
    getSentryUtil().resetUser();
  }
);
